import React, { FC } from 'react';
import { useIntl } from 'react-intl';

import { Notification } from '@xsolla/ui-core';
import { AlertExclamation } from '@xsolla/ui-icons';

export const FormInfoCard: FC = () => {
  const intl = useIntl();
  return (
    <Notification palette="brand" icon={AlertExclamation}>
      {intl.formatMessage({ id: 'authorization.settings.babkaLogin.info.displayed-details' })}
    </Notification>
  );
};
